import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { ElDialog } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Dialog',
    props: {
        modelValue: { type: Boolean },
        allowClosing: { type: Boolean, default: true },
        destroyOnClose: { type: Boolean },
        showClose: { type: Boolean, default: true },
        title: {}
    },
    emits: ["update:modelValue", "closed"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const shouldShowDialog = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit("update:modelValue", value);
            },
        });
        const customClass = computed(() => props.allowClosing ? "" : "hide-close-button");
        const closed = () => {
            shouldShowDialog.value = false;
            emit("closed");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDialog), {
                modelValue: shouldShowDialog.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((shouldShowDialog).value = $event)),
                title: _ctx.title,
                closeOnClickModal: _ctx.allowClosing,
                customClass: customClass.value,
                destroyOnClose: _ctx.destroyOnClose,
                appendToBody: true,
                showClose: _ctx.showClose,
                onClosed: closed
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["modelValue", "title", "closeOnClickModal", "customClass", "destroyOnClose", "showClose"]));
        };
    }
});
